import { render } from "./PublishVideo.vue?vue&type=template&id=55641e90"
import script from "./PublishVideo.vue?vue&type=script&lang=js"
export * from "./PublishVideo.vue?vue&type=script&lang=js"

import "./PublishVideo.vue?vue&type=style&index=0&id=55641e90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__